import React from "react";

interface ValidationMessageProps {
  type: "error" | "success" | "info";
  message: string;
}

export const ValidationMessage: React.FC<ValidationMessageProps> = ({
  type,
  message,
}) => {
  const getIcon = () => {
    switch (type) {
      case "error":
        return "✗";
      case "success":
        return "✓";
      case "info":
        return "ℹ";
      default:
        return "";
    }
  };

  return (
    <div className={`validation-message ${type} mt-1`}>
      <span className="validation-icon">{getIcon()}</span>
      <span>{message}</span>
    </div>
  );
};
